export default __webpack_public_path__ + "static/media/weebly.f6032c9c.svg";